import type { BaseThemePrepared} from '@archipro-design/aria';
import { tileOverlayClassName } from '@archipro-design/aria';
import {
    archizeenTileSlotClassNames,
    buttonClassName,
} from '@archipro-design/aria';
import {
    archizeenTileClassName,
    avatarClassName,
    avatarSlotClassNames,
    captionClassName,
    fileTileClassName,
    fileTileSlotClassNames,
    flexClassName,
    productTileClassName,
    professionalTileClassName,
    professionalTileSlotClassNames,
    projectTileClassName,
    pxArrayToRem,
    pxToRem,
    SubheaderClassName,
    tileImageClassName,
} from '@archipro-design/aria';
import {
    PRODUCT_TILE_HEIGHT_MOBILE,
    PRODUCT_TILE_WIDTH_MOBILE,
    PROFESSIONAL_TILE_HEIGHT_MOBILE,
    PROJECT_TILE_HEIGHT_MOBILE,
    ARCHIZEEN_TILE_WIDTH_MOBILE,
    TILE_WIDTH_MOBILE,
    UPLOAD_TILE_HEIGHT_MOBILE,
    UPLOAD_TILE_WIDTH_MOBILE,
} from '~/modules/design-board/config';

export const PinTilesMobile = (theme: BaseThemePrepared) => ({
    [`& .${productTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: pxToRem(PRODUCT_TILE_WIDTH_MOBILE),
            height: pxToRem(PRODUCT_TILE_HEIGHT_MOBILE),
        },
    },

    [`& .${projectTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: pxToRem(TILE_WIDTH_MOBILE),
            height: pxToRem(PROJECT_TILE_HEIGHT_MOBILE),
        },
    },

    [`& .${professionalTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            width: pxToRem(TILE_WIDTH_MOBILE),
            height: pxToRem(PROFESSIONAL_TILE_HEIGHT_MOBILE),
        },

        [`& .${professionalTileSlotClassNames.content}`]: {
            [`& .${avatarClassName}`]: {
                height: pxToRem(108),
                width: pxToRem(108),
                margin: pxArrayToRem([-83, 0, 18, -6]),

                [`& .${avatarSlotClassNames.image}`]: {
                    height: '100%',
                    width: '100%',
                },
            },

            [`& .${professionalTileSlotClassNames.textWrap}`]: {
                marginLeft: pxToRem(-7),
            },
        },
    },

    [`& a.${archizeenTileClassName}`]: {
        paddingBottom: pxToRem(17),
        borderBottom: `1px solid ${theme.siteVariables.colors.grey[150]}`,
        [`& .${tileImageClassName}`]: {
            width: pxToRem(ARCHIZEEN_TILE_WIDTH_MOBILE),
        },
        [`& > .${flexClassName}`]: {
            justifyContent: 'flex-start',
            [`& .${SubheaderClassName}`]: {
                fontSize: pxToRem(18),
                letterSpacing: theme.siteVariables.letterSpacingSmall,
                marginBottom: pxToRem(25),
            },
            [`& > .${flexClassName}`]: {
                [`& > .${captionClassName}`]: {
                    fontSize: pxToRem(10),
                    letterSpacing: '0.08em',
                    ':first-child': {
                        fontWeight: '500',
                        marginBottom: pxToRem(6),
                    },
                },
                '& > span': {
                    marginRight: pxToRem(5),
                },
            },

            [`& .${archizeenTileSlotClassNames.extraActions}`]: {
                width: pxToRem(40),
                [`& .${buttonClassName}`]: {
                    width: pxToRem(32),
                    height: pxToRem(32),
                    margin: pxArrayToRem([-2, 0, 0, 4]),
                    '& span': {
                        marginRight: 0,
                    },
                },
            },
        },

        '&.odd': {
            paddingBottom: pxToRem(21),
            [`& .${tileImageClassName}`]: {
                height: pxToRem(120),
            },
            [`& > .${flexClassName}`]: {
                [`& .${SubheaderClassName}`]: {
                    marginBottom: pxToRem(13),
                },
            },
        },
    },

    [`& .${fileTileClassName}`]: {
        [`& .${tileImageClassName}`]: {
            height: pxToRem(UPLOAD_TILE_HEIGHT_MOBILE),
            width: pxToRem(UPLOAD_TILE_WIDTH_MOBILE),

            [`& .${tileOverlayClassName}`]: {
                padding: pxToRem(8),
            },
        },

        [`& .${fileTileSlotClassNames.contentWrap}`]: {
            margin: pxArrayToRem([18, 0, 0, 1]),
            width: pxToRem(UPLOAD_TILE_WIDTH_MOBILE),
            display: 'block',

            [`& .${captionClassName}`]: {
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                paddingLeft: pxToRem(12),
            },
        },

        '&.upload-file-pin': {
            [`& .${fileTileSlotClassNames.extensionText}`]: {
                margin: pxArrayToRem([-47, 0, 0, -29]),
                minWidth: pxToRem(47),
                justifyContent: 'center',
            },
            [`& .${fileTileSlotClassNames.contentWrap}`]: {
                margin: pxArrayToRem([27, 0, 0, 1]),
            },
        },
    },
});
